import React from 'react';
import { useSelector } from 'react-redux';

import FormTitle from 'components/PageLayout/FormTitle';
import { Button } from 'components/curo-components/common/Button';
import { CuroApplicationVariables } from 'enums/curo/Variables';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import { TableValue } from 'product_modules/api/Types';
import styled from 'types/AppTheme';
import { formatToMonetary } from 'utils/curo-helpers/formatters';


import styles from './EndPages.module.scss';
import { CALL_US_BUTTON_TEXT } from './constants';

const StyledLink = styled.a`
  color: inherit;
`;

const PAGE_TITLE = 'Congratulations!';

const getAddressLink = (branchStreet: string, branchCityStateZip: string) => {
  const encodedAddressStreet = encodeURIComponent([branchStreet, branchCityStateZip].join(' '));
  const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddressStreet}`;

  return (
    <StyledLink
      target="_blank"
      href={mapsUrl}
      rel="noopener noreferrer"
    >
      {branchStreet}
      <br />
      {branchCityStateZip}
    </StyledLink>
  );
};

const getPageDescription = (phone: string, loanAmount: string, branchStreet: string, branchCityStateZip: string) => (
  <p className={styles.descriptionWrapper}>
   We are pleased to share that you are conditionally approved for <strong>{loanAmount}</strong>. The only remaining step is to visit your branch and provide your bank account information and proof of identity. 
   One of our team members will contact you to discuss these final steps.
    <br />
    <br />
    Can’t wait to talk? You can call us right now!
    <br />
    <strong>{phone}</strong>
    <br />
    <strong>{getAddressLink(branchStreet, branchCityStateZip)}</strong>
  </p>
);

const ApplicationOnlineOriginationFailedPage = () => {
  const application = useSelector(getApplicationSelector);

  const branchPhone = application?.variables[CuroApplicationVariables.SnowflakeBorrowerBranchPhone] as string;
  const branchStreet = application?.variables[CuroApplicationVariables.BranchStreet] as string;
  const branchCityStateZip = application?.variables[CuroApplicationVariables.BranchCityStateZip] as string;

  const loanAmount = (
    application?.variables[CuroApplicationVariables.AvailableLoanOffers] as TableValue
  )?.[0]?.loan_amount as number || 0;

  const callByPhone = () => {
    window.open(`tel:${branchPhone}`, '_self');
  };

  return (
    <>
      <FormTitle 
        title={PAGE_TITLE} 
        subTitle={getPageDescription(branchPhone, formatToMonetary(loanAmount), branchStreet || '', branchCityStateZip || '')} 
      />
      <Button onClick={callByPhone} kind="primary" size="form">
        {CALL_US_BUTTON_TEXT}
      </Button>
    </>
  );
};

export default ApplicationOnlineOriginationFailedPage;
